
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { 
  Plus,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CurrentList } from "../currentList/currentList";
import { HistoryList } from "../historyList/historyList";
import { Summary } from "../summary";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

const ServiceLandingPage = () => {
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">Service Request Management</h1>
          <p className="page-subtitle">View, filter and manage service requests and orders.</p>
        </div>
        <div className="flex gap-2">
        <Button onClick={() => {
          localStorage.removeItem(`service-request-progress-${remoteUtilityId}`);
          navigate("/cx/services/create");
        }}>
            <Plus className="mr-2 h-4 w-4" />
            Create Service
          </Button>
        </div>
      </div>

      <Summary />

      <div className="flex flex-col space-y-4">
      <Tabs 
        defaultValue="current"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        urlMapping={{
          current: "current",
          history: "history",
        }}
        tabComponents={{
          current: {
            label: "Current",
            component: <CurrentList />
          },
          history: {
            label: "History",
            component: <HistoryList />
          }
        }}
      />

      </div>
    </div>
  );
};

export default ServiceLandingPage;
